import { useEffect, useState } from 'react'
import * as Fingerprint2 from 'fingerprintjs2'
import { isIE } from '../lib/utils'

export default function useDeviceFingerprint() {
  const [deviceFingerprint, setDeviceFingerprint] = useState(() => {
    return localStorage.getItem('deviceUUID') || null
  })

  useEffect(() => {
    if (deviceFingerprint) return

    const FP_OPTIONS = {
      excludeJsFonts: true,
      excludeAdBlock: true,
      excludeDoNotTrack: true,
      excludeIndexedDB: true
    }

    if (isIE()) {
      FP_OPTIONS.excludeCanvas = true
      FP_OPTIONS.excludeWebGL = true
    }

    Fingerprint2.get(FP_OPTIONS, (results) => {
      const values = results.map(result => result.value)
      const hashedResult = Fingerprint2.x64hash128(values.join(''), 31)
      localStorage.setItem('deviceUUID', hashedResult)
      setDeviceFingerprint(hashedResult)
    })
  }, [deviceFingerprint])

  return deviceFingerprint
}
